import loadable from 'react-loadable';
import { LoaderComponent } from '../../components';

export const VehiclesList = loadable({
  loader: () => import('./VehiclesList'),
  loading: LoaderComponent
});

export const VehicleManualUpload = loadable({
  loader: () => import('./VehicleManualUpload'),
  loading: LoaderComponent
});

export const LocationsList = loadable({
  loader: () => import('./Locations/list'),
  loading: LoaderComponent
});

export const AuctionsList = loadable({
  loader: () => import('./AuctionsList'),
  loading: LoaderComponent
});

export const AuctionDetail = loadable({
  loader: () => import('./AuctionDetail'),
  loading: LoaderComponent
});

export const CustomersList = loadable({
  loader: () => import('./CustomersList'),
  loading: LoaderComponent
});

export const AccountsList = loadable({
  loader: () => import('./AccountsList'),
  loading: LoaderComponent
});

export const AccountLogsList = loadable({
  loader: () => import('./AccountLogsList'),
  loading: LoaderComponent
});

export const AdminSellers = loadable({
  loader: () => import('./AdminSellers'),
  loading: LoaderComponent
});

export const CustomerDetailPage = loadable({
  loader: () => import('./CustomerDetailPage'),
  loading: LoaderComponent
});

export const BuyerFeesPage = loadable({
  loader: () => import('./BuyerFeesPage'),
  loading: LoaderComponent
});

export const AuctionSummaryReportPage = loadable({
  loader: () => import('./AuctionSummaryReportPage'),
  loading: LoaderComponent
});

export const ListerSummaryReportPage = loadable({
  loader: () => import('./ListerSummaryReportPage'),
  loading: LoaderComponent
});

export const BuyersDocs = loadable({
  loader: () => import('./Users/Documents/BuyerDocs'),
  loading: LoaderComponent
});

export const DeclinedCardsPage = loadable({
  loader: () => import('./DeclinedCardsPage'),
  loading: LoaderComponent
});

export const AdditionalFeesPage = loadable({
  loader: () => import('./AdditionalFeesPage'),
  loading: LoaderComponent
});

export const BannersList = loadable({
  loader: () => import('./BannersList'),
  loading: LoaderComponent
});

export const TransactionsList = loadable({
  loader: () => import('./TransactionsList'),
  loading: LoaderComponent
});

export const SiteStatisticsDetails = loadable({
  loader: () => import('./SiteStatisticsDetails'),
  loading: LoaderComponent
});

export const SiteStatistics = loadable({
  loader: () => import('./SiteStatistics'),
  loading: LoaderComponent
});

export const Logs = loadable({
  loader: () => import('./Logs'),
  loading: LoaderComponent
});
